import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  LOGIN: '/dh-datamaint/login/login',
  LOGOUT: '/dh-datamaint/login/out'
};

class AccountModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async login(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.LOGIN, payload.data);
    },

    async logout(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.LOGOUT, payload.data);
    }
  };
}

export const accountModule = new AccountModule();
